import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { StateService } from "../../../services/state.service";
import { EventService } from "../../../services/event.service";
import { Event } from "../../../pojo/Event";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { ModalCopyEditEventComponent } from "../../../standalone/more-actions/edit/modal.copy.edit.event.component";
import { ModalService } from "../../modal/modal.service";

@TypeManagerDecorator("s25-ng-opt-edit-event-button")
@Component({
    selector: "s25-ng-opt-edit-event-button",
    template: `
        @if (isInit && moreActionPerms?.hasEditEvent) {
            <s25-ng-button [type]="'link'" class="ngInlineBlock ngOptElementPad" (clicked)="editEvent()">
                <s25-ng-icon [type]="'edit'" [ariaLabel]="false" />
                Edit Event
            </s25-ng-button>
        }
    `,
    styles: `
        s25-ng-button {
            font-size: 1.25em;
        }

        s25-ng-icon {
            vertical-align: text-bottom;
            font-size: 0.8667em;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25OptEditEventButtonComponent implements OnInit {
    @Input() itemId: number;
    @Input() itemTypeId: number;

    moreActionPerms: Event.Permissions.CopyEditEmail;
    isInit: boolean = false;

    constructor(private changeDetector: ChangeDetectorRef) {}

    async ngOnInit() {
        if (!this.itemId || this.itemTypeId != 1) return;
        this.moreActionPerms = await EventService.formEventCopyEditEmailPermsFromId(this.itemId);
        this.isInit = true;
        this.changeDetector.detectChanges();
    }

    async editEvent() {
        await this.updateCopyEventPerms();
        if (this.moreActionPerms.hasRelatedEvents) {
            await ModalService.byClass(ModalCopyEditEventComponent, { eventId: this.itemId, type: "edit" });
        } else {
            StateService.gotoRose({
                itemId: this.itemId,
                itemTypeId: this.itemTypeId,
            });
        }
    }

    async updateCopyEventPerms() {
        const itemData = await EventService.getMoreActionsData(this.itemId);
        this.moreActionPerms.hasRelatedEvents = itemData && !!itemData.has_related;
    }
}
